// test354
(354 && 0);
